import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import * as S from "./style";
import { UrlInternal } from "common/constants/endpoints";

type dataMenu = {
  title: string;
  url: string;
  subUrl?: string;
  subUrl2?: string;
};
interface Props {
  data: dataMenu[];
  isShowMultipleLang?: boolean;
}

function TabHeader({ data, isShowMultipleLang }: Props) {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [hasScroll, setHasScroll] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkScroll = () => {
      setHasScroll(el.scrollWidth > el.clientWidth);
    };

    // 초기 체크
    checkScroll();

    // 리사이즈 시 다시 체크
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [data]);

  return (
    <S.Wrapper className="wrapper-menu">
      <S.Container ref={containerRef} isCentered={!hasScroll}>
        {data.map((item, index) => (
          <S.Tab
            key={index}
            onClick={() => {
              if (
                window.location.pathname.includes(
                  UrlInternal.PATHNAME_GROUP_SALE
                ) ||
                window.location.pathname.includes(UrlInternal.PATHNAME_MYPAGE)
              ) {
                window.location.href = item.url;
              } else {
                history.push(item.url);
              }
            }}
            active={
              location.pathname.includes(item.url) ||
              (!!item.subUrl && location.pathname.includes(item.subUrl)) ||
              (!!item.subUrl2 && location.pathname.includes(item.subUrl2))
            }
          >
            {isShowMultipleLang ? item.title : t(item.title)}
          </S.Tab>
        ))}
      </S.Container>
    </S.Wrapper>
  );
}

export default TabHeader;
